import React from "react";
import { Box } from "@mui/material";
import DashboardKpiCards from "../components/dashboard/DashboardKpiCards";
import GlobalShipmentMap from "../components/dashboard/GlobalShipmentMap";
import DashboardAlerts from "../components/dashboard/DashboardAlerts";
import ShipmentValueDistribution from "../components/dashboard/ShipmentValueDistribution";
import TopSuppliersByValue from "../components/dashboard/TopSuppliersByValue";

const DashboardPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        p: { xs: 2, md: 3 },
        bgcolor: "#F7F7F7",
        display: "flex",
        flexDirection: "column",
        gap: { xs: 3, md: 4 },
      }}
    >
      {/* KPI Cards (includes title section) */}
      <DashboardKpiCards />

      {/* Map + Alerts row */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
        gap: { xs: 3, md: 4 },
      }}
      >
        <Box sx={{ flex: 2, minWidth: 0 }}>
          <GlobalShipmentMap />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <DashboardAlerts />
        </Box>
      </Box>

      {/* Charts row */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: 3, md: 4 },
        }}
      >
        <Box sx={{ flex: { xs: "1 1 auto", lg: "0 0 38%" }, minWidth: 0 }}>
          <ShipmentValueDistribution />
        </Box>
        <Box sx={{ flex: { xs: "1 1 auto", lg: "0 0 62%" }, minWidth: 0 }}>
          <TopSuppliersByValue />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardPage;
